import { useThemeUI } from 'theme-ui';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var StarRating = function StarRating(_ref) {
  var _theme$compounds$card;

  var _ref$starsNumber = _ref.starsNumber,
      starsNumber = _ref$starsNumber === void 0 ? 5 : _ref$starsNumber,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 2.5 : _ref$value,
      EndIcon = _ref.EndIcon,
      variant = _ref.variant;
  var theme = useThemeUI().theme;

  var getVariant = function getVariant(element) {
    return "elements.starRating.".concat(variant ? variant + '.' + element : element);
  };

  var displayedValue = value;

  try {
    displayedValue = value.toFixed(1);
  } catch (_unused) {
    console.error('Could not parse value');
  }

  var StarIcon = function StarIcon(variant) {
    return _jsx(DynamicSparkIcon, {
      glyph: "star-".concat(variant),
      size: 18
    });
  };

  var stars = [];

  for (var counter = 1; counter <= starsNumber; counter++) {
    variant = ''; // if value is x.5 icon is half filled star, outlined otherwise

    if (counter > value) variant = counter - 0.5 == displayedValue ? 'half-filled' : 'outlined';else variant = 'filled';
    stars.push(StarIcon(variant));
  }

  return _jsxs("div", {
    sx: {
      display: 'flex',
      p: 'xxs',
      alignItems: 'center',
      variant: getVariant('base')
    },
    children: [_jsx("div", {
      sx: {
        fontSize: 'lg',
        color: (_theme$compounds$card = theme.compounds.card) === null || _theme$compounds$card === void 0 ? void 0 : _theme$compounds$card.scoreColor,
        fontWeight: 'bold',
        mr: 'xs',
        variant: getVariant('value')
      },
      children: displayedValue
    }), stars.map(function (star, key) {
      return _jsx("div", {
        sx: {
          mr: 'xs',
          variant: getVariant('star')
        },
        children: star
      }, key);
    }, this), EndIcon ? EndIcon : null]
  });
};

export default StarRating;
//# sourceMappingURL=star-rating.js.map